import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ArrendatarioEntry } from 'src/app/shared/entrys/arrendatario.entry';
import { ArrendatarioService } from './arrendatario.service';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
// tslint:disable-next-line:max-line-length
import { ConfirmarRespuestaType, TipoConfirmacionModalType, ConfirmarRespuestaModel } from 'src/app/shared/models/confirmar-respuesta.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { NgbModal, NgbDate, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { RegistroCuentaService } from 'src/app/components/seguridad/containers/registrar/registro-cuenta.service';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { isDate } from 'util';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AyudasService } from 'src/app/components/contenido/containers/ayudas/ayudas.service';

@Component({
	selector: 'app-arrendatario',
	templateUrl: './arrendatario.component.html',
	styleUrls: ['./arrendatario.component.scss']
})
export class ArrendatarioComponent implements OnInit {
	dataTabla: DatoPaginadoModel;
	headersArrendatario: Array<string>;
	formArrendamiento: FormGroup;
	selectArrendatario: ArrendatarioEntry;
	rnt: RNTPrestadorEntry;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	dataVerificacion: {
		correo_electronico: string,
		razon_social: string,
		telefono_reportado: string
	};
	fecha_inicio: any;
	fecha_inicio_arredatario: any;
	tipo_prestador = RolesUsuario.Prestador;
	paginaActual: number;

	constructor(private formBuilder: FormBuilder, private arrendatarioService: ArrendatarioService,
		public calendar: NgbCalendar, public authService: AuthService,
		private dataSharedService: DataSharedService, private modalService: NgbModal,
		private registroServicio: RegistroCuentaService, public ayudaService: AyudasService) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.dataSharedService.data$.subscribe(resultado => {
			this.datoSolicitudSharedModel = resultado as DatoSolicitudSharedModel;
			this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
		});
		this.formArrendamiento = formBuilder.group({
			nit: ['', Validators.required],
			digito_verificacion: ['', Validators.required],
			fecha_inicio_arrendamiento: ['', Validators.required],
			fecha_fin_arrendamiento: ['', Validators.required],
			activo: [''],
			correo_electronico: [{
				value: '',
				disabled: true
			}, [Validators.required, ConfirmeValidators.emailValidator]],
			razon_social: [{ value: '', disabled: true }, Validators.required],
			telefono_reportado: [{
				value: '',
				disabled: true
			}, [Validators.required, , ConfirmeValidators.numberValidator]]
		});
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.headersArrendatario = ['Razón Social', 'Correo Electrónico', 'Teléfono', 'NIT', 'Digito de Verificación',
			'Fecha Inicio', 'Fecha Fin', 'Estado', 'Acciones'];
		this.cargarArrendatarios();
	}

	cargarArrendatarios() {
		this.paginaActual = 1;
		this.arrendatarioService.getPaginado(1, {
			codigo_camara: this.rnt.codigo_camara,
			establecimiento_id: this.rnt.establecimiento_id
		}).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
			}
		});
	}

	onOperarArrendatario(): void {
		if (!this.selectArrendatario) {
			this.onAgregarArrendatario();
		} else {
			this.onModificarArrendatario();
		}
	}

	onAgregarArrendatario() {
		this.arrendatarioService.create({
			...this.formArrendamiento.value,
			...this.dataVerificacion,
			numero_telefonico: this.dataVerificacion.telefono_reportado,
			codigo_camara: this.rnt.codigo_camara,
			establecimiento_id: this.rnt.establecimiento_id,
			activo: true
		}).subscribe(resultado => {
			if (resultado.result) {
				if (!this.dataTabla || !this.dataTabla.items) {
					this.cargarArrendatarios();
				} else {
					this.dataTabla.items.push({ ...resultado.data });
				}
				this.formArrendamiento.reset();
			}
		});
	}

	onMinFechaFin(minDate: NgbDate) {
		this.fecha_inicio = { day: minDate.day, month: minDate.month, year: minDate.year };
	}

	onCargarEditarArrendatario(entry: ArrendatarioEntry) {
		this.formArrendamiento.patchValue({
			nit: entry.nit,
			digito_verificacion: entry.digito_verificacion,
			fecha_inicio_arrendamiento: new Date(entry.fecha_inicio_arrendamiento),
			fecha_fin_arrendamiento: new Date(entry.fecha_fin_arrendamiento),
			correo_electronico: entry.correo_electronico,
			razon_social: entry.razon_social,
			telefono_reportado: entry.numero_telefonico,
			activo: entry.activo
		});
		this.formArrendamiento.controls['nit'].disable();
		this.formArrendamiento.controls['digito_verificacion'].disable();
		this.selectArrendatario = entry;
	}

	onModificarArrendatario() {
		const dato = this.formArrendamiento.value as ArrendatarioEntry;
		const arrendatario = { ...this.selectArrendatario } as ArrendatarioEntry;
		arrendatario.fecha_inicio_arrendamiento = dato.fecha_inicio_arrendamiento;
		arrendatario.fecha_fin_arrendamiento = dato.fecha_fin_arrendamiento;
		arrendatario.activo = dato.activo;
		this.arrendatarioService.update({
			...arrendatario as any,
			codigo_camara: this.rnt.codigo_camara,
			detalle_solicitud_id: this.rnt.detalle_solicitud_id
		}).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla.items
				[this.dataTabla.items.indexOf(this.selectArrendatario)] = arrendatario;
				this.selectArrendatario = null;
				this.formArrendamiento.controls['nit'].enable();
				this.formArrendamiento.controls['digito_verificacion'].enable();
				this.formArrendamiento.reset();
			}
		});
	}

	onEliminarArrendatario(entry: ArrendatarioEntry) {
		this.arrendatarioService.delete({
			arrendatario_id: entry.arrendatario_id,
			codigo_camara: this.rnt.codigo_camara,
			establecimiento_id: this.rnt.establecimiento_id
		} as ArrendatarioEntry).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla.items.splice(this.dataTabla.items.indexOf(entry), 1);
				this.selectArrendatario = null;
				this.formArrendamiento.reset();
				this.formArrendamiento.controls['nit'].enable();
				this.formArrendamiento.controls['digito_verificacion'].enable();
			}
		});
	}

	onPaginado(value: number) {
		this.arrendatarioService.getPaginado(value, {
			codigo_camara: this.rnt.codigo_camara,
			establecimiento_id: this.rnt.establecimiento_id
		}).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
			}
		});
		this.paginaActual = value;
	}


	onValidarPrestador() {
		if (this.formArrendamiento.value.nit
			&& this.formArrendamiento.value.digito_verificacion) {
			this.registroServicio
				.get({
					nit: this.formArrendamiento.value.nit,
					dv: this.formArrendamiento.value.digito_verificacion,
					tipo_identificacion_id: this.formArrendamiento.value.tipo_identificacion_id
				}).subscribe((resultado) => {
					if (resultado.result) {
						this.dataVerificacion = resultado.data;
						this.formArrendamiento.controls['correo_electronico'].setValue(this.dataVerificacion.correo_electronico);
						this.formArrendamiento.controls['correo_electronico'].disable();
						this.formArrendamiento.controls['razon_social'].setValue(this.dataVerificacion.razon_social);
						this.formArrendamiento.controls['razon_social'].disable();
						this.formArrendamiento.controls['telefono_reportado'].setValue(this.dataVerificacion.telefono_reportado);
						this.formArrendamiento.controls['telefono_reportado'].disable();
					}
					if (this.dataVerificacion.correo_electronico.trim().length < 1) {
						const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
						const confirmarRespuesta = {} as ConfirmarRespuestaModel;
						confirmarRespuesta.tipoConfirmacionModalType = TipoConfirmacionModalType.Alerta;
						confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
						confirmarRespuesta.buttonTextAlert = 'Entendido';
						// tslint:disable-next-line:max-line-length
						confirmarRespuesta.message = 'El usuario no cuenta con la información suficiente para realizar el registro, comuniquese con soporte.';
						modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
						modalRef.result.then((resultadoModal) => {
							this.formArrendamiento.reset();
						});
					}
				},
					(error) => {
						this.formArrendamiento.reset();
					});
		}
	}

}
